import { render, staticRenderFns } from "./TrackingDetails.vue?vue&type=template&id=4f8d45fb&scoped=true"
import script from "./TrackingDetails.vue?vue&type=script&lang=ts"
export * from "./TrackingDetails.vue?vue&type=script&lang=ts"
import style0 from "./TrackingDetails.vue?vue&type=style&index=0&id=4f8d45fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d45fb",
  null
  
)

export default component.exports